import { NavbarLink } from "./NavbarLink";
import { NavbarLinksWrapper } from "./NavbarlinksWrapper";

export const NavbarLinks = () => {
  return (
    <NavbarLinksWrapper>
      <NavbarLink href="/">Home</NavbarLink>
      <NavbarLink href="/explore">I&apos;m an athlete</NavbarLink>
      <NavbarLink
        href="https://coaches.pod1um.com"
        className="hidden lg:inline"
      >
        I&apos;m a coach
      </NavbarLink>
    </NavbarLinksWrapper>
  );
};
